// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__22heD","error":"Textarea_error__pbKBn","readonly":"Textarea_readonly__2sffM","disabled":"Textarea_disabled__1S5P4"};